import styled from '@emotion/styled';

export const Container = styled.div`
    display: flex;
    flex-direction: column;
    gap: ${({ theme }) => theme.spacing[4]};
`;

export const WarningBanner = styled.div`
    display: flex;
    align-items: flex-start;
    gap: ${({ theme }) => theme.spacing[2]};
    padding: ${({ theme }) => theme.spacing[3]};
    background-color: ${({ theme }) => theme.color.io.warning100};
    border: 1px solid ${({ theme }) => theme.color.io.warning500};
    border-radius: ${({ theme }) => theme.radius.main};

    & > i {
        color: ${({ theme }) => theme.color.io.warning500};
        font-size: 20px;
        flex-shrink: 0;
    }
`;

export const WarningText = styled.span`
    font-size: ${({ theme }) => theme.font.size.small};
    color: ${({ theme }) => theme.color.black400};
`;

export const Section = styled.div`
    display: flex;
    flex-direction: column;
`;

export const SectionTitle = styled.h3`
    font-size: ${({ theme }) => theme.font.size.normal};
    font-weight: ${({ theme }) => theme.font.weight.medium};
    color: ${({ theme }) => theme.color.black};
    margin: 0 0 ${({ theme }) => theme.spacing[2]} 0;
`;

export const DescriptionList = styled.ol`
    font-family: ${({ theme }) => theme.font.family};
    padding-left: ${({ theme }) => theme.spacing[4]};
    margin: 0;
`;

export const DescriptionItem = styled.li`
    font-size: ${({ theme }) => theme.font.size.small};
    font-weight: ${({ theme }) => theme.font.weight.light};
    color: ${({ theme }) => theme.color.black400};
    margin-bottom: ${({ theme }) => theme.spacing[1]};
`;

export const DropzoneContainer = styled.div`
    &,
    > * {
        width: 100%;
    }
`;

export const Link = styled.span`
    color: ${({ theme }) => theme.color.electricBlue};
    cursor: pointer;
    text-decoration: underline;

    &:hover {
        opacity: 0.8;
    }
`;

export const OptionsContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: ${({ theme }) => theme.spacing[2]};
    padding: ${({ theme }) => theme.spacing[3]};
    background-color: ${({ theme }) => theme.color.grey100};
    border-radius: ${({ theme }) => theme.radius.main};
`;
